import React, { useEffect, useRef } from "react";
import AccountGroupCard from "./AccountGroupCard";
import GroupFileCard from "./GroupFileCard";

const SearchModal = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  
  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
  <>
      <div onClick={handleClick} className="flex items-center justify-center">
        <div className="flex items-center gap-2 pb-3">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.1931 2.58187C13.5249 4.91369 13.5249 8.69432 11.1931 11.0261C8.86128 13.358 5.08065 13.358 2.74883 11.0261C0.417014 8.69432 0.417014 4.91369 2.74883 2.58187C5.08065 0.250053 8.86128 0.250053 11.1931 2.58187Z" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.15 11.0601L17 16.9901" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input ref={inputRef} type="text" className="outline-none w-[670px] text-[#0f0c18] text-base font-medium" />
        </div>
      </div>
    <hr />
    <div className="px-4 mt-2">
      <p className="text-[#9392A2] text-xs font-medium mb-2">Recent searches</p>
      <div className="flex items-center gap-2.5 cursor-pointer border-b border-[#EAE9EF] py-3 hover:bg-[#f1f2f8] px-3 rounded-lg">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.1931 2.58187C13.5249 4.91369 13.5249 8.69432 11.1931 11.0261C8.86128 13.358 5.08065 13.358 2.74883 11.0261C0.417014 8.69432 0.417014 4.91369 2.74883 2.58187C5.08065 0.250053 8.86128 0.250053 11.1931 2.58187Z" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.15 11.0601L17 16.9901" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <p className="text-[#0F0C18] text-base font-medium leading-none select-none">Video</p>
      </div>
      <div className="flex items-center gap-2.5 cursor-pointer border-b border-[#EAE9EF] py-3 hover:bg-[#f1f2f8] px-3 rounded-lg">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.1931 2.58187C13.5249 4.91369 13.5249 8.69432 11.1931 11.0261C8.86128 13.358 5.08065 13.358 2.74883 11.0261C0.417014 8.69432 0.417014 4.91369 2.74883 2.58187C5.08065 0.250053 8.86128 0.250053 11.1931 2.58187Z" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.15 11.0601L17 16.9901" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <p className="text-[#0F0C18] text-base font-medium leading-none select-none">Vlog</p>
      </div>
      <div className="flex items-center gap-2.5 cursor-pointer border-b border-[#EAE9EF] py-3 hover:bg-[#f1f2f8] px-3 rounded-lg">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.1931 2.58187C13.5249 4.91369 13.5249 8.69432 11.1931 11.0261C8.86128 13.358 5.08065 13.358 2.74883 11.0261C0.417014 8.69432 0.417014 4.91369 2.74883 2.58187C5.08065 0.250053 8.86128 0.250053 11.1931 2.58187Z" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.15 11.0601L17 16.9901" stroke="#9392A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <p className="text-[#0F0C18] text-base font-medium leading-none select-none">Project A</p>
      </div>
      <div>
        <p className="text-[#9392A2] mb-2 mt-8 text-xs font-medium tracking-tight">Accounts</p>
        <div className="flex items-center gap-2 flex-wrap">
          {
            [...Array(4)].map((_, index) => <AccountGroupCard key={index} width="358px" className="border border-[#EAE9EF] rounded-lg" /> )
          }
        </div>
      </div>
      <div>
        <p className="text-[#9392A2] mb-2 mt-8 text-xs font-medium tracking-tight">Group files</p>
        <div className="flex items-center gap-2 flex-wrap">
          {
            [...Array(4)].map((_, index) => <GroupFileCard key={index} width="358px" className="border border-[#EAE9EF] rounded-lg" /> )
          }
        </div>
      </div>
    </div>
  </>
  );
};

export default SearchModal;